module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0132.jpg?v=b809a28f";